module.exports = __webpack_public_path__ + "static/media/468x60_0054_ru.80a98cfc.jpg";